import DTBackend from "@/services/DTBackend";
import Image from "@/services/Image";

export class WishPresenter {
    constructor(data) {
        this._reactiveData = data || {}
    }

    get wish_id() { return this._reactiveData.wish_id }
    set wish_id(val) { this._reactiveData.wish_id = val }

    get wish_title() { return this._reactiveData.wish_title }
    set wish_title(val) { this._reactiveData.wish_title = val }

    get wish_category_id() { return this._reactiveData.wish_category_id }
    set wish_category_id(val) { this._reactiveData.wish_category_id = val }

    get wish_content_user() { return this._reactiveData.wish_content_user }
    set wish_content_user(val) { this._reactiveData.wish_content_user = val }

    get wish_content_public() { return this._reactiveData.wish_content_public }
    set wish_content_public(val) { this._reactiveData.wish_content_public = val }

    get wish_themes() { return this._reactiveData.wish_themes }
    set wish_themes(val) { this._reactiveData.wish_themes = val }

    get wish_currency_id() { return this._reactiveData.wish_currency_id }
    set wish_currency_id(val) { this._reactiveData.wish_currency_id = val }

    get wish_budget() { return this._reactiveData.wish_budget }
    set wish_budget(val) { this._reactiveData.wish_budget = val }

    get wish_links() { return this._reactiveData.wish_links }
    set wish_links(val) { this._reactiveData.wish_links = val }

    get getWishUser() {
        return this._reactiveData.wish_user ?? {}
    }

    get userName() {
        return this.getWishUser?.user_name ?? ""
    }

    userAvatar(w, h) {
        let host = this.getWishUser?.user_avatar_host ?? null
        let name = this.getWishUser?.user_avatar_name ?? null

        if (host && name) {
            return Image.handle(host, name, w, h)
        }

        return "/assets/static/user/no_image.jpg"
    }

    get rawData() { return this._reactiveData }

    get wishCreatedFormatted() {
        if (!this._reactiveData?.wish_created) return '';

        let dt = new DTBackend(this._reactiveData.wish_created).correctTZGet()
        return dt.get("%D.%M.%y <span>%H:%I</span>")
    }
}
